__turbopack_context__.v({
  "button": "Button-module__HC5zgW__button",
  "full": "Button-module__HC5zgW__full",
  "icon": "Button-module__HC5zgW__icon",
  "label": "Button-module__HC5zgW__label",
  "pill": "Button-module__HC5zgW__pill",
  "s-lg": "Button-module__HC5zgW__s-lg",
  "s-md": "Button-module__HC5zgW__s-md",
  "s-sm": "Button-module__HC5zgW__s-sm",
  "uppercase": "Button-module__HC5zgW__uppercase",
  "v-ghost": "Button-module__HC5zgW__v-ghost",
  "v-outline": "Button-module__HC5zgW__v-outline",
  "v-ruby": "Button-module__HC5zgW__v-ruby",
  "v-solid": "Button-module__HC5zgW__v-solid",
});
